/**
 * Suggested life categories shown as placeholders for users to create.
 * These are display-only suggestions, not stored in the database.
 *
 * Search: life categories, category suggestions, life design presets
 */
export const LIFE_CATEGORY_SUGGESTIONS = [
  "Identity & Values",
  "Health & Wellbeing",
  "Personal Growth",
  "Vision, Purpose & Legacy",
  "Love & Intimacy",
  "Family",
  "Social & Contribution",
  "Money & Career/Business",
  "Lifestyle, Experiences & Environment",
] as const;

export type LifeCategorySuggestion = (typeof LIFE_CATEGORY_SUGGESTIONS)[number];
